const reactLearnCode = `
Microsoft Windows [Version 10.0.22621.2283]
(c) Microsoft Corporation. All rights reserved.

C:/React/ProjectFolder> npx create-react-app FirstApp`;

const reactNpmStart = `
Microsoft Windows [Version 10.0.22621.2283]
(c) Microsoft Corporation. All rights reserved.

C:/React/ProjectFolder> npm start`;



export const learnerReactData = {
    reactLearnCode,
    reactNpmStart
}